export const styledOptions = {
  shouldForwardProp: (prop: PropertyKey) => typeof prop !== 'string' || !prop.startsWith('$'),
};
